import { EMPTY_OBJECT } from 'constants/frozenObjects'
import { SUBSCRIPTION_STATUS } from 'constants/subscription'
import { NOTIFICATION_NAMES } from './constants'

interface IParams {
  isUserConfirmedEmail?: boolean,
  isPlanAcceptedMessageShown?: boolean,
  isCardExpired?: boolean,
  subscriptionStatus?: SUBSCRIPTION_STATUS,
  isPrinterWillBeSentSoon?: boolean,
  isRenewalProcessAvailable: boolean,
  isSubscriptionRenewed: boolean,
  isEnrollAvailable: boolean,
  futureSubscription?: any,
}

export const getActiveNotificationNames = ({
  isUserConfirmedEmail,
  isPlanAcceptedMessageShown,
  isCardExpired,
  subscriptionStatus,
  isPrinterWillBeSentSoon,
  isRenewalProcessAvailable,
  isSubscriptionRenewed,
  isEnrollAvailable,
  futureSubscription,
}: IParams) => {
  const notifications = []
  if (isUserConfirmedEmail === false && subscriptionStatus !== SUBSCRIPTION_STATUS.canceled) {
    notifications.push(NOTIFICATION_NAMES.notConfirmedEmail)
  }
  if (isPlanAcceptedMessageShown) {
    notifications.push(NOTIFICATION_NAMES.printWillBeDelivered)
  }
  if (isCardExpired) {
    notifications.push(NOTIFICATION_NAMES.cardExpired)
  }
  if (subscriptionStatus === SUBSCRIPTION_STATUS.waitingForPrinter) {
    notifications.push(NOTIFICATION_NAMES.askingReturnPrinter)
  }
  if (subscriptionStatus === SUBSCRIPTION_STATUS.canceled) {
    notifications.push(NOTIFICATION_NAMES.subscriptionCanceled)
  }
  if ((subscriptionStatus === SUBSCRIPTION_STATUS.renewed && isSubscriptionRenewed)) {
    notifications.push(NOTIFICATION_NAMES.subscriptionRenewed)
  }
  if (isRenewalProcessAvailable && !isEnrollAvailable) {
    notifications.push(NOTIFICATION_NAMES.subscriptionWillExpireSoon)
  }
  if (isEnrollAvailable) {
    notifications.push(NOTIFICATION_NAMES.subscriptionExpired)
  }
  if (subscriptionStatus === SUBSCRIPTION_STATUS.pendingPayment) {
    notifications.push(NOTIFICATION_NAMES.checkCreditCard)
  }
  if (subscriptionStatus === SUBSCRIPTION_STATUS.pendingLocked) {
    notifications.push(NOTIFICATION_NAMES.printerWillBeLocked)
  }
  if (subscriptionStatus === SUBSCRIPTION_STATUS.locking) {
    notifications.push(NOTIFICATION_NAMES.printerLocking)
  }
  if (subscriptionStatus === SUBSCRIPTION_STATUS.locked) {
    notifications.push(NOTIFICATION_NAMES.printerLocked)
  }
  if (subscriptionStatus === SUBSCRIPTION_STATUS.pendingUnlocked) {
    notifications.push(NOTIFICATION_NAMES.printerWillBeUnlocked)
  }
  if (isPrinterWillBeSentSoon) {
    notifications.push(NOTIFICATION_NAMES.printerWillBeSoon)
  }
  return notifications
}
